// Design tokens for the Daily Reporting module.
// Single source of truth for color and status meaning, so every card,
// badge, table row and chart in this module agrees with each other.

export const ACCENT = "#4F46E5"; // indigo — brand / interactive
export const ACCENT_SOFT = "#EEF2FF";

export const STATUS_META = {
  Completed: {
    label: "Completed",
    text: "text-emerald-700",
    bg: "bg-emerald-50",
    border: "border-emerald-200",
    dot: "#059669",
  },
  "In Progress": {
    label: "In progress",
    text: "text-sky-700",
    bg: "bg-sky-50",
    border: "border-sky-200",
    dot: "#0284C7",
  },
  "Not Started": {
    label: "Not started",
    text: "text-amber-700",
    bg: "bg-amber-50",
    border: "border-amber-200",
    dot: "#D97706",
  },
};

export const PRIORITY_META = {
  High: { label: "High", text: "text-rose-700", bg: "bg-rose-50", dot: "#E11D48" },
  Medium: { label: "Medium", text: "text-amber-700", bg: "bg-amber-50", dot: "#D97706" },
  Low: { label: "Low", text: "text-slate-600", bg: "bg-slate-100", dot: "#64748B" },
};

export function getStatusMeta(status) {
  return (
    STATUS_META[status] || {
      label: status || "Unknown",
      text: "text-slate-500",
      bg: "bg-slate-50",
      border: "border-slate-200",
      dot: "#94A3B8",
    }
  );
}

export function getPriorityMeta(priority) {
  return (
    PRIORITY_META[priority] || {
      label: priority || "—",
      text: "text-slate-400",
      bg: "bg-slate-50",
      dot: "#CBD5E1",
    }
  );
}

export function initials(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

// A task counts as overdue if it isn't complete and its due date has
// already passed. Kept defensive since due_date/status can be absent.
export function isOverdue(task) {
  if (!task || task.status === "Completed") return false;
  if (!task.due_date) return false;
  const today = new Date().toISOString().slice(0, 10);
  return task.due_date < today;
}

// Kept so any existing import of CMS_PRIMARY doesn't break.
export const CMS_PRIMARY = ACCENT;

export const CLASS_BTN_PRIMARY = "daily-report-btn-primary";
export const CLASS_BTN_CHIP = "daily-report-btn-chip";
export const CLASS_BTN_CHIP_ACTIVE = "daily-report-btn-chip-active";
export const CLASS_BTN_GHOST = "daily-report-btn-ghost";

// Tailwind utility fallbacks (scoped CSS classes above win when Bootstrap leaks)
export const BTN_CHIP = `${CLASS_BTN_CHIP} border-0 shadow-none outline-none`;
export const BTN_CHIP_ACTIVE = `${CLASS_BTN_CHIP_ACTIVE} border-0 shadow-none outline-none`;
export const BTN_PRIMARY = `${CLASS_BTN_PRIMARY} border-0 shadow-none outline-none`;
export const BTN_GHOST = `${CLASS_BTN_GHOST} border-0 shadow-none outline-none`;
export const BTN_ATTENTION = "daily-report-btn-attention border-0 shadow-none outline-none";